export default __webpack_public_path__ + "static/HarmoniaSansPro-Light-5ef4292c8b5a0aaa8bcb8305025f2997.woff";